import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import { IOrganizacaoEmail } from "../../../../Interfaces/Organizacao/Organizacao";
import { faRetweet } from "@fortawesome/free-solid-svg-icons";

interface IOrganizacaoInfoEmail {
    infoEmail: IOrganizacaoEmail | undefined;
    handleEditarInformacaoFormSubmit: (formData: IOrganizacaoEmail) => void;
    EditarInformacaoLoading: boolean;
}

export default function InfoEmail(props: IOrganizacaoInfoEmail) {
    const FormMethods = useForm();

    return (
        <FormProvider {...FormMethods}>
            <UnForm
                usingContext
                handleSubmit={props.handleEditarInformacaoFormSubmit}
                className="row justify-content-center"
            >
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="DS_USUARIO_EMAIL"
                        label="Usuário Email"
                        defaultValue={props.infoEmail?.DS_USUARIO_EMAIL}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="password"
                        name="DS_SENHA_EMAIL"
                        label="Senha"
                        defaultValue={props.infoEmail?.DS_SENHA_EMAIL}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="DS_REMETENTE_EMAIL"
                        label="Remetente Email"
                        defaultValue={props.infoEmail?.DS_REMETENTE_EMAIL}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="DS_SMTP_EMAIL"
                        label="SMTP Email"
                        defaultValue={props.infoEmail?.DS_SMTP_EMAIL}
                    />
                </div>
                <div className="form-group col-6">
                    <label>
                        <span>SSL Email Habilitado</span>
                    </label>
                    <div className="mr-8 d-flex align-items-center">
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_ENABLE_SSL_EMAIL"
                                style={{ transform: "scale(2)" }}
                                value={"true"}
                                defaultChecked={
                                    props.infoEmail?.FL_ENABLE_SSL_EMAIL
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Sim</span>
                            </label>
                        </div>
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_ENABLE_SSL_EMAIL"
                                style={{ transform: "scale(2)" }}
                                value={"false"}
                                defaultChecked={
                                    !props.infoEmail?.FL_ENABLE_SSL_EMAIL
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Não</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="form-group col-6">
                    <label>
                        <span>Enviar Email</span>
                    </label>
                    <div className="mr-8 d-flex align-items-center">
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_ENVIAR_EMAIL"
                                style={{ transform: "scale(2)" }}
                                value={"true"}
                                defaultChecked={
                                    props.infoEmail?.FL_ENVIAR_EMAIL
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Sim</span>
                            </label>
                        </div>
                        <div className="mr-8 d-flex align-items-center">
                            <UnForm.Input
                                type="radio"
                                name="FL_ENVIAR_EMAIL"
                                value={"false"}
                                style={{ transform: "scale(2)" }}
                                defaultChecked={
                                    !props.infoEmail?.FL_ENVIAR_EMAIL
                                        ? true
                                        : false
                                }
                            />
                            <label className="ml-4">
                                <span>Não</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="text"
                        name="ID_ONESIGNAL"
                        label="ID Onesignal"
                        defaultValue={props.infoEmail?.ID_ONESIGNAL}
                    />
                </div>
                <div className="form-group col-6">
                    <UnForm.Input
                        type="number"
                        name="NR_PORTA_SMTP_EMAIL"
                        label="Porta SMTP Email"
                        defaultValue={props.infoEmail?.NR_PORTA_SMTP_EMAIL}
                    />
                </div>
                <UnForm.SubmitButton
                    wrapperClassName="d-flex col-12 justify-content-end align-items-end mt-3 mr-0 p-0"
                    className="col-12"
                    loading={props.EditarInformacaoLoading}
                    icon={faRetweet}
                    color="success"
                    loadingSize="sm"
                >
                    Editar
                </UnForm.SubmitButton>
            </UnForm>
        </FormProvider>
    );
}
